<template>
    <div>
        <b-breadcrumb>
            <b-breadcrumb-item to="/">
                <i class="fa fa-home"></i>
                Home
            </b-breadcrumb-item>
            <b-breadcrumb-item to="/Facilities/Keys">Facilities</b-breadcrumb-item>
            <b-breadcrumb-item active>Keys</b-breadcrumb-item>
        </b-breadcrumb>

        <div class="card">
            <div class="card-header">
                <ul class="card-header-tabs nav nav-tabs">
                    <li class="nav-item">
                        <RouterLink :to="{name:'Keys'}" class="active nav-link">
                            Keys
                        </RouterLink>
                    </li>
                    <li class="nav-item">
                        <RouterLink :to="{name:'Locks'}" class="nav-link">
                            Locks
                        </RouterLink>
                    </li>
                </ul>
            </div>
            <div class="card-body">
                <!-- The collapsable filter options -->
                <AppFormCardCollapsable :display-footer="true" @submit.prevent="onFilterSubmit()" class="mb-3">
                    <template v-slot:header>Filter</template>
                    <template v-slot:body>
                        <div class="form-row justify-content-center">
                            <div class="col-auto form-group">
                                <label for="facilitiesKeyTypeId">Type</label>
                                <select class="form-control" v-model="filterOptions.facilitiesKeyTypeId">
                                    <option :value="null">All</option>
                                    <option :key="type.id" :value="type.id" v-for="type in facilitiesKeyTypeList">{{type.name}}</option>
                                </select>
                            </div>
                            <div class="col-md-4 col-sm-6 form-group">
                                <label>Organization</label>
                                <input
                                        class="form-control"
                                        placeholder="Organization Code"
                                        v-model="filterOptions.issuedToPersonOrganizationCode"
                                />
                            </div>
                        </div>
                        <div class="form-row justify-content-center">
                            <div class="col-auto form-group">
                                <label for="facilitiesKeyNumber">Key Number</label>
                                <input
                                        class="form-control"
                                        placeholder="Key Number"
                                        v-model="filterOptions.facilitiesKeyNumber"
                                />
                            </div>
                            <div class="col-md-4 col-sm-6 form-group">
                                <label>Issued to Name</label>
                                <input
                                        class="form-control"
                                        placeholder="Name"
                                        v-model="filterOptions.issuedToName"
                                />
                            </div>
                        </div>
                    </template>
                    <template v-slot:footer>
                        <button class="btn btn-primary" type="submit">Apply</button>
                    </template>
                </AppFormCardCollapsable>
                <div class="card">
                    <div class="bg-dark card-header text-white">Keys</div>
                    <div class="card-body">
                        <div class="d-print-none dropdown mb-3 text-right">
                            <button aria-expanded="false" aria-haspopup="true" class="btn btn-secondary dropdown-toggle"
                                    data-toggle="dropdown" style="width: 100px" type="button">
                                <span>Actions</span>
                            </button>
                            <div class="dropdown-menu">
                                <RouterLink :to="{name: 'AddKey'}" class="btn btn-outline-light dropdown-item text-left"
                                            title="Add New Key">
                                    <i class="fa fa-plus"></i>Add
                                </RouterLink>
                            </div>
                        </div>
                        <BTable :busy="isLoading"
                                :fields="tableFields"
                                :items="facilitiesKeys"
                                :responsive="true"
                                primary-key="id"
                                show-empty
                                striped
                                table-class="table-align-middle">

                            <template v-slot:cell(id)="row">
                                <div class="btn-group col-auto">
                                    <router-link
                                            :to="{name:'KeyDetails',params:{id:row.item.id,keyNumber:row.item.keyNumber}}"
                                            class="btn btn-sm btn-primary d-print-none"
                                            data-toggle="tooltip"
                                            title="View key details">
                                      View
                                    </router-link>
                                    <button v-if="row.item.canBeDeleted" @click="onDeleteClick(row.item)" class="btn btn-danger btn-sm d-print-none"
                                            type="button"><i class="fa fa-trash"></i>Delete
                                    </button>
                                </div>
                            </template>

                            <template v-slot:cell(createdDate)="row">
                                <span>{{ row.item.createdDate | moment('MM/DD/YYYY') }}</span>
                            </template>

                            <!-- Footer Pagination -->
                            <template v-slot:custom-foot>
                                <b-tr>
                                    <b-td :colspan="tableFields.length">
                                        <AppTablePagination
                                                :page.sync="filterOptions.page"
                                                :pageSize.sync="filterOptions.pageSize"
                                                :totalCount.sync="totalFacilitiesKeys"
                                                v-on:update:page="loadData()"
                                                v-on:update:pageSize="loadData()"
                                        ></AppTablePagination>
                                    </b-td>
                                </b-tr>
                            </template>
                        </BTable>
                    </div>
                </div>
            </div>

    </div>
    

    <AppModalConfirm :visible="deletingRow" @close="deletingRow=null" @confirm="onDeleteConfirmed(deletingRow)">
        <template v-slot:header>Confirm</template>
        <p v-if="deletingRow">Are you sure you want to delete key {{ deletingRow.keyNumber }}? Doing so will delete all data associated with the key.</p>
    </AppModalConfirm>
</template>

<script>
    import {ToastType} from "@/services/models/shared/ToastType";
    import AppTablePagination from "../../components/shared/AppTablePagination";
    import FacilitiesKeysService from "@/services/FacilitiesKeysService";
    import { FacilitiesKeyType } from "@/services/models/FacilitiesKey";
    import AppFormCardCollapsable from "@/components/shared/AppFormCardCollapsable";
    import AppModalConfirm from "@/components/shared/AppModalConfirm";

    export default {
        components: {
            AppTablePagination,
            AppFormCardCollapsable,
            AppModalConfirm
        },
        data() {
            return {
                buildings: [],
                organizations: [],
                facilitiesKeys: [],
                totalFacilitiesKeys: 0,
                deletingRow: null,
                filterOptions: {
                    page: 1,
                    pageSize: 10,
                    returnAll: false,
                    facilitiesKeyTypeId: null,
                    facilitiesKeyCopyStatusId: null,
                    hookNumber: null,
                    buildingId: null,
                    lockIdentity: null,
                    issuedToName: null,
                    issuedToPersonOrganizationCode: null,
                    facilitiesKeyNumber: null
                },
                isLoading: false,
                tableFields: [
                    {
                        key: 'id',
                        label: '',
                        thStyle: 'width:200px'
                    }, 
                    {
                        key: 'keyNumber',
                        label: 'Key Number'
                    },
                    {
                        key: 'facilitiesKeyTypeName',
                        label: 'Type'
                    },
                    {
                        key: 'numberOfKeyCopies',
                        label: 'Number of Copies',
                    },
                    {
                        key: 'createdDate',
                        label: 'Created Date',
                    }
                ]
            }
        },
        computed: {
          facilitiesKeyTypeList () {
              return (Object.keys(FacilitiesKeyType)).map(val => {
                return {
                    id: FacilitiesKeyType[val],
                    name: val.toString()
                }
              })
          }
        },
        methods: {
            loadData() {
                const vm = this;
                vm.isLoading = true;

                FacilitiesKeysService.getFacilitiesKeys(vm.filterOptions)
                  .then(response => {
                    vm.facilitiesKeys = response.data;
                    vm.totalFacilitiesKeys = response.totalCount;
                  })
                  .catch(() => {
                    vm.redirectToError()
                  })
                  .finally(() => {
                    vm.isLoading = false;
                  })
            },
            /**
             * @description Resets the page to the first page and reloads the data
             */
            onFilterSubmit() {
                this.filterOptions.page = 1;
                this.loadData();
            },
            
            /**
             * @description Opens up a modal to confirm deletion of the key
             */
            onDeleteClick(key) {
                this.deletingRow = key;
            },

            /**
             * @description When the user clicks 'Confirm' - the selected key will be deleted and the modal will be closed.
             */
            onDeleteConfirmed(deletingRow) {
                const vm = this;

                FacilitiesKeysService.deleteFacilitiesKey(deletingRow.id)
                    .then(() => {
                        vm.alert(ToastType.Success, `The key was successfully deleted`);

                        // Reload the data on the page
                        vm.loadData();
                    }).catch(error => {
                      vm.alert(ToastType.Danger, error.response.data);
                    }).finally(() => {
                      vm.deletingRow = null;
                    })
            }
        },
        created() {
            this.loadData();
        }
    }
</script>
